<style>
</style>

<template>
  <div id="watercourses" class="pages">
    <watercourses-map></watercourses-map>
    <router-view></router-view>
  </div>
</template>

<script>
import WatercoursesMap from '../components/WatercoursesMap.vue';

export default {
  components: {
    WatercoursesMap
  }
};
</script>
